import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '[app-status-row]',
  templateUrl: './status-row.component.html',
  styleUrls: ['./status-row.component.scss']
})
export class StatusRowComponent implements OnInit {

  @Input() status: string;
  @Input() topText: string = "";
  @Input() userInfo: string = "";
  @Input() bottomText: string = "";
  @Input() last: boolean = false;

  constructor() { }

  ngOnInit() { }

}
